export const LOCAL_STORAGE_USER = "FUSER";
export const NO_IMAGE_PATH = "/images/no-image-for-event.jpg";
export const KEY_EVENT_ID = "eventId";
export const FOLDER_EVENT_PHOTO = "/eventPhoto/";
export const FOLDER_ORGANIZER_LOGO = "/businessLogo/";
export const LOCAL_CART_EVENT = "LOCAL_CART_EVENT";
export const LOCAL_CART_USER_DETAILS = "LOCAL_CART_USER_DETAILS";
